import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { QuoteCartProvider } from "@/context/QuoteCartContext";
import { AuthProvider } from "@/context/AuthContext";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import QuoteRequest from "@/pages/QuoteRequest";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Wholesale from "@/pages/Wholesale";
import Contact from "@/pages/Contact";
import Partnerships from "@/pages/Partnerships";
import SampleBox from "@/pages/SampleBox";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsConditions from "@/pages/legal/TermsConditions";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import LegalNotice from "@/pages/legal/LegalNotice";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminQuotes from "@/pages/admin/Quotes";
import AdminSampleBoxes from "@/pages/admin/SampleBoxes";
import AdminBlog from "@/pages/admin/Blog";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <QuoteCartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/request-quote" element={<QuoteRequest />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/about" element={<About />} />
                <Route path="/wholesale" element={<Wholesale />} />
                <Route path="/partnerships" element={<Partnerships />} />
                <Route path="/sample-box" element={<SampleBox />} />
                <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/legal/terms-conditions" element={<TermsConditions />} />
                <Route path="/legal/cookie-policy" element={<CookiePolicy />} />
                <Route path="/legal/notice" element={<LegalNotice />} />
                <Route path="/contact" element={<Contact />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="quotes" element={<AdminQuotes />} />
                <Route path="sample-boxes" element={<AdminSampleBoxes />} />
                <Route path="blog" element={<AdminBlog />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors theme="light" />
        </QuoteCartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
